<template lang="pug">
div
  el-divider 显示格式
  el-form-item(label="显示格式")
    el-select(v-model="format")
      el-option(v-for="{ id, cnName } in formatList", :key="id", :label="cnName", :value="id")
  el-divider 关联更新
  el-form-item(label="项目名称")
    fieldSetting(v-model="prjName")
  el-form-item(label="项目编号")
    fieldSetting(v-model="prjCode")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { V_FORM_PRJ_ENUM } from "./schema";

export default {
  mixins: [settingMixin],
  computed: {
    ...mapVFOptions("prjName", "prjCode", "format"),
    formatList() {
      return [
        { id: V_FORM_PRJ_ENUM.format_code_name, cnName: "编号-项目名称" },
        { id: V_FORM_PRJ_ENUM.format_name, cnName: "项目名称" }
      ];
    }
  }
};
</script>

<style>
</style>
